// Core
import React from "react";
import moment from "moment";

// Styles
import "./styles.scss";

// Custom component
import Button from "Components/Button";

const PastAssessmentCard = ({
  data,
  userName,
  handleViewRecommendation,
  handleViewReport,
  handleViewAssessment,
  assessmentName,
  assessorName,
  referenceName,
  assessmentSubmittedDate,
  approvalStatus = 2,
  showViewReport=true,
  showViewRecommendations=true,
}) => {
  const outlineButton = {
    width: "100%",
    height: "44px",
    backgroundColor: approvalStatus === 1 || approvalStatus === 3 ? "#e0e0e0" : "white",
    border:
      approvalStatus === 1 ? "1.5px solid #cccccc" : "1.5px solid #1F2155",
    textAlign: "center",
    borderRadius: "5px",
    // marginRight: "10px",
    marginTop: "10px",
  };
  const outlineTitle = {
    color: approvalStatus === 1 || approvalStatus === 3  ? "#9e9e9e" : 
    "#1F2155",
    fontSize: "20px",
    fontWeight: "600",
  };
  return (
    <div className="pastAssessmentCardWrap">
  <div className="assessmentTitle my-2">{assessmentName}</div>

  <div className="assessment-layout">
    {/* LEFT SECTION */}
    <div className="assessment-info">
      <div className="assessment-info-details">
        <p>
          <span className="label">Submitted Date</span>
          <span className="value">: {assessmentSubmittedDate}</span>
        </p>
        <p style={{ display: "grid", gridTemplateColumns: "100px 1fr", gap: "8px" }}>
          <span className="label">KG Assessor</span>
          <span className="value">: {assessorName}</span>
        </p>
        <p>
          <span className="label">Submitted By</span>
          <span className="value">: {userName ?? "-"}</span>
        </p>
        <p className="reference">
          <span className="label">Reference Number</span>
          <span className="value">: {referenceName ?? "-"}</span>
        </p>
      </div>
    </div>

    {/* RIGHT SECTION */}
    <div className="button-section">
      {showViewReport && (
        <>
          <Button
            title="View Report"
            buttonStyle={outlineButton}
            titleStyle={outlineTitle}
            onClick={handleViewReport}
            disabled={approvalStatus === 1 || approvalStatus === 3}
          />

          <Button
            title="View Assessment"
            buttonStyle={{
              width: "100%",
              height: "44px",
              backgroundColor:
                // approvalStatus === 1 || approvalStatus === 3 ? "#e0e0e0" : 
                "white",
              border:
                // approvalStatus === 1 ? "1.5px solid #cccccc" :
                 "1.5px solid #1F2155",
              textAlign: "center",
              borderRadius: "5px",
              marginTop: "10px",
            }}
            titleStyle={{
              color: 
              // approvalStatus === 1 || approvalStatus === 3  ? "#9e9e9e" : 
    "#1F2155",
    fontSize: "20px",
    fontWeight: "600",
            }}
            onClick={handleViewAssessment}
            // disabled={approvalStatus === 1 || approvalStatus === 3}
          />
        </>
      )}
      {showViewRecommendations && (
        <Button
          title="View Recommendations"
          buttonStyle={outlineButton}
          titleStyle={outlineTitle}
          onClick={handleViewRecommendation}
          disabled={approvalStatus === 1 || approvalStatus === 3}
        />
      )}
    </div>
  </div>
</div>

  );
};

export default PastAssessmentCard;
